import { MakerApplicationStages } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/useMakerSignUpForm";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { IPublicRetailer } from "@faire/web-api--source/indigofair/data/IPublicRetailer";

type MakerSignUpStore = {
  acceptedTerms: boolean;
  referringBrand?: IBrand;
  referringRetailer?: IPublicRetailer;
  applicationStage?: MakerApplicationStages;
};

const {
  useStore: useMakerSignUpContextStore,
  Provider: MakerSignUpContextStoreProvider,
} = createContextStore<MakerSignUpStore>(
  {
    acceptedTerms: false,
    applicationStage: undefined,
  },
  {
    name: "MakerSignUpStore",
  }
);

export { useMakerSignUpContextStore, MakerSignUpContextStoreProvider };
